import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  'QPN820WO0Q',
  '52557bf2c07e2a0440469a77ece8385a'
);
